import { useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { logger } from '../lib/logger';

/**
 * Dezenter Banner am oberen Bildrand. Sichtbar nur wenn:
 *  - Logger-Verbosity in 'tester' oder 'dev'
 *  - DEV-Build (import.meta.env.DEV === true)
 *
 * Klickbarer Schließen-Button für die laufende Session (nicht persistiert).
 */
export function TesterModeBanner() {
  const [dismissed, setDismissed] = useState(false);
  const verbosity = logger.getVerbosity();
  const visible =
    !dismissed && import.meta.env.DEV && (verbosity === 'tester' || verbosity === 'dev');

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 2000,
        bgcolor: 'info.dark',
        color: 'info.contrastText',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        py: 0.5,
        minHeight: 28,
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 500 }}>
        🔬 Tester-Modus aktiv — F12 öffnet die Konsole — Strg+Shift+L kopiert Logs
      </Typography>
      <IconButton
        size="small"
        onClick={() => setDismissed(true)}
        sx={{ color: 'inherit' }}
        aria-label="Tester-Banner schließen"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
